import './App.css';
import { useState, useEffect } from 'react';
import Home from './Home';
import Spinner from './components/Spinner';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Show spinner for 2 seconds (or until resources load)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {isLoading && <Spinner />}
      {!isLoading && <Home />}
    </div>
  );
}

export default App;
